import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M13.5 3.75 9 20.25h1.5L15 3.75h-1.5ZM5.953 4.805l-5.062 6.75L.562 12l.329.445 5.062 6.75 1.219-.89L2.438 12l4.734-6.305-1.219-.89Zm12.094 0-1.219.89L21.563 12l-4.735 6.305 1.219.89 5.062-6.75.328-.445-.328-.445-5.062-6.75Z" />
  </svg>
);

export default icon;
